import moment from 'moment';
import config from '../../../config';
export var isDraft = function (campaign) { return campaign.status === 'draft'; };
export var isScheduled = function (campaign) { return campaign.status === 'scheduled'; };
export var isCompleted = function (campaign) { return campaign.status === 'completed'; };
export var isSending = function (campaign) { return campaign.status === 'sending'; };
export var isRecurringCampaign = function (campaign) {
    return !!campaign.recurring && campaign.status === 'recurring_scheduled';
};
export var isPausedRecurringCampaign = function (campaign) {
    return isRecurringCampaign(campaign) && campaign.recurringNextOccurrenceDateTime === null;
};
export var isActiveRecurringCampaign = function (campaign) {
    return isRecurringCampaign(campaign) && campaign.recurringNextOccurrenceDateTime !== null;
};
export var getLastTimeRecurringWasSent = function (campaign, timezone) {
    if (!isRecurringCampaign(campaign)) {
        return null;
    }
    var startDateTime = moment.tz("".concat(campaign.recurringStartDate, " ").concat(campaign.recurringTime), 'YYYY-MM-DD HH:mm', timezone);
    var endDateTime = moment.tz("".concat(campaign.recurringEndDate, " ").concat(campaign.recurringTime), 'YYYY-MM-DD HH:mm', timezone);
    var now = moment.tz(timezone);
    if (now.isBefore(startDateTime)) {
        return null;
    }
    var deadlineDate = endDateTime.isBefore(now) ? endDateTime : now;
    var diff = deadlineDate.diff(startDateTime, 'days');
    var lastSentDateTime = startDateTime.clone().add(diff - (diff % campaign.recurringFrequency), 'days');
    return lastSentDateTime.format(config.dateTimeFormat);
};
var getLastTimeScheduledWasSent = function (campaign) {
    if (!isScheduled(campaign)) {
        return null;
    }
    var now = moment();
    var scheduledAtMoment = moment(campaign.scheduledAt);
    return now.isBefore(scheduledAtMoment) ? null : scheduledAtMoment.format(config.dateTimeFormat);
};
export var getCampaignLastSentDate = function (campaign, timezone) {
    if (isDraft(campaign)) {
        return null;
    }
    if (isScheduled(campaign)) {
        return getLastTimeScheduledWasSent(campaign);
    }
    if (isCompleted(campaign)) {
        return moment(campaign.completedAt).format(config.dateTimeFormat);
    }
    if (isRecurringCampaign(campaign)) {
        return getLastTimeRecurringWasSent(campaign, timezone || config.defaultTimezone);
    }
    return null;
};
export var getOpenRatePercent = function (campaign) {
    return 100 * (campaign.totalUniqueOpenRateCounter / campaign.totalCustomersNotified);
};
export var isUpdateCampaign = function (campaign) { return campaign.type === 'update'; };
export var isPromotionCampaign = function (campaign) {
    return campaign.type === 'promotion' || campaign.type === 'recurring' || campaign.type === 'referral';
};
